import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Avatar,
} from "@material-ui/core";
import useStyles from "./FilterStyle";
import ReactImageLightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // Styles for Lightbox

import "./style.css";
import moment from "moment";
import { useParams } from "react-router-dom";
import Geocode from "react-geocode";
import MediaGallery from "./MediaGallery";
import LayoutGallery from "./LayoutGallery";
import {
  AccountCircle,
  Apartment,
  AspectRatio,
  AssignmentInd,
  Ballot,
  Bathtub,
  ContactMail,
  DriveEta,
  Email,
  HomeWork,
  Hotel,
  LocationCity,
  LocationOn,
  Person,
  Phone,
  PhotoLibrary,
  Store,
} from "@mui/icons-material";
import {
  BrandSettingByLocation,
  Entity,
} from "../../../Api Mutation/EntityApi";
import PoweredBy from "../../../common/PoweredBy";
import BusinessFavicon from "../../../common/BusinessFavicon";
import config from "../../../config";
import { showNotification } from "../../../components/Notification/ToastifyNotifications";
import {
  convertToUSPhoneNumber,
  handleUndefined,
  postDataRequestPublic,
} from "../../../common/commonfunctions";
import { LoadingPage } from "../../LoadingPage/LoadingPage";
import { RealestatePropertyById } from "../../../Api Mutation/PropertyAPI";
import { CurrencySymbol } from "../../../common/const";
import GoogleMapComponent from "./GoogleMapComponent";

const PropertyPublicPage = () => {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);
  const [imgLoad, setImgLoad] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [propertyDetails, setPropertyDetails] = useState();
  const [favIcon, setFavIcon] = useState();
  const [brandImage, setBrandImage] = useState();
  const [locationBrandImage, setLocationBrandImage] = useState();
  const [floorPlans, setPropertyFloorPlans] = useState([]);
  const [businessId, setBusinessId] = useState([]);
  const [propertyImages, setPropertyImages] = useState([]);
  const [locationLogo, setLocationLogo] = useState("");
  const { pid, lid } = useParams();
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [openFloorDialog, setOpenFloorDialog] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // Lightbox state
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isFloorOpen, setIsFloorOpen] = useState(false); // Lightbox state
  const [currentFloorImageIndex, setCurrentFloorImageIndex] = useState(0);
  const [galleryImages, setGalleryImages] = useState([]);
  const [galleryFloorImages, setGalleryFloorImages] = useState([]);

  const GOOGLE_MAPS_API_KEY = config.googleMapApi;

  Geocode.setApiKey(GOOGLE_MAPS_API_KEY);

  useEffect(() => {
    if (propertyDetails?.address) {
      Geocode?.fromAddress(propertyDetails.address)
        .then((response) => {
          const { lat, lng } = response?.results[0]?.geometry?.location;
          setCoordinates({ lat, lng });
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }, [propertyDetails]);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleOpenFloorDialog = () => {
    setOpenFloorDialog(true);
  };

  const handleCloseFloorDialog = () => {
    setOpenFloorDialog(false);
  };

  const getpropertyData = () => {
    if (pid) {
      setDataLoading(true);
      postDataRequestPublic(config.baseURLApi, {
        query: RealestatePropertyById,
        variables: {
          realestatepropertyid: pid,
        },
      }).then((res) => {
        if (res?.errors && res?.errors[0]?.message) {
          showNotification(res.errors[0].message, "error");
          setDataLoading(false);
        } else if (res?.data?.realestateProperty) {
          const propertyArr = [
            {
              label: "City",
              value: handleUndefined(res?.data?.realestateProperty?.city),
              icon: <LocationCity />,
            },
            {
              label: "State",
              value: handleUndefined(res?.data?.realestateProperty?.state),
              icon: (
                <img
                  alt=""
                  src="https://storage.cloud.google.com/bixpand-staging/WebsiteImages/State.png"
                  width={23}
                  height={23}
                />
              ),
            },
            {
              label: "Zip Code",
              value: handleUndefined(res?.data?.realestateProperty?.zipcode),
              icon: <LocationOn />,
            },
            {
              label: "County",
              value: handleUndefined(res?.data?.realestateProperty?.county),
              icon: <Store />,
            },
            // { label: "Country", value: handleUndefined(res?.data?.realestateProperty?.country), icon: <Public /> },
            {
              label: "Square Feet",
              value: handleUndefined(res?.data?.realestateProperty?.squarefeet),
              icon: <AspectRatio />,
            },
            {
              label: "Bedrooms",
              value: handleUndefined(res?.data?.realestateProperty?.bedroom),
              icon: <Hotel />,
            },
            {
              label: "Bathrooms",
              value: handleUndefined(res?.data?.realestateProperty?.bathroom),
              icon: <Bathtub />,
            },
            {
              label: "Garage",
              value: handleUndefined(res?.data?.realestateProperty?.cargarage),
              icon: <DriveEta />,
            },
            {
              label: "MLS ID",
              value: handleUndefined(res?.data?.realestateProperty?.mlsid),
              icon: <ContactMail />,
            },
            {
              label: "Property Type",
              value: handleUndefined(
                res?.data?.realestateProperty?.propertytype
              ),
              icon: <Apartment />,
            },
            {
              label: "Lot Size",
              value: handleUndefined(res?.data?.realestateProperty?.lotsize),
              icon: <Ballot />,
            },
            {
              label: "Build Year",
              value: handleUndefined(res?.data?.realestateProperty?.builtyear)
                ? moment(res?.data?.realestateProperty?.builtyear).format(
                    "yyyy"
                  )
                : "-",
              icon: <HomeWork />,
            },
          ];
          setPropertyData(propertyArr);
          setPropertyFloorPlans(res?.data?.realestateProperty?.floorplan);
          setPropertyDetails(res?.data?.realestateProperty);
          const hasPhotos = res?.data?.realestateProperty?.photos?.length > 0;
          setImgLoad(!hasPhotos);
          setPropertyImages(res?.data?.realestateProperty?.photos);
          setDataLoading(false);
        }
      });
    }
  };

  const getEntityData = () => {
    if (lid) {
      setDataLoading(true);
      const ENTITYDATA = Entity;
      postDataRequestPublic(config.baseURLApi, {
        query: ENTITYDATA,
        variables: {
          entityid: lid,
        },
      }).then((res) => {
        if (res?.data?.entity) {
          setLocationLogo(res?.data?.entity?.logourl);
          setBusinessId(res?.data?.entity?.parententityid);
          if (res?.data?.entity?.parententityid) {
            postDataRequestPublic(config.baseURLApi, {
              query: ENTITYDATA,
              variables: {
                entityid: res?.data?.entity?.parententityid,
              },
            }).then((respo) => {
              if (respo?.data?.entity) {
                setDataLoading(false);
              }
            });
            postDataRequestPublic(config.baseURLApi, {
              query: BrandSettingByLocation,
              variables: {
                locationid: res?.data?.entity?.parententityid,
              },
            }).then((resp) => {
              setBrandImage(resp?.data?.brandSettingByLocation?.logourl);
              setDataLoading(false);
            });
          }
        }
      });
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted && lid) {
      getEntityData();
    }
    return () => {
      isMounted = false;
    };
  }, [lid]);

  useEffect(() => {
    let isMounted = true;

    if (pid && isMounted) {
      getpropertyData();
    }
    return () => {
      isMounted = false;
    };
  }, [pid]);

  const getMediaDetails = async (url) => {
    return new Promise((resolve) => {
      const fileExtension = url.split(".").pop().toLowerCase();

      if (
        fileExtension === "jpg" ||
        fileExtension === "jpeg" ||
        fileExtension === "png" ||
        fileExtension === "gif" ||
        fileExtension === "bmp" ||
        fileExtension === "webp"
      ) {
        // It's an image
        const img = new Image();
        img.src = url;
        img.onload = () => {
          const width = img.width;
          const height = img.height;
          resolve({ src: url, type: "image", width, height });
        };
      } else if (
        fileExtension === "mp4" ||
        fileExtension === "avi" ||
        fileExtension === "mov" ||
        fileExtension === "mkv"
      ) {
        // It's a video
        const video = document.createElement("video");
        video.src = url;
        video.onloadedmetadata = () => {
          const width = video.videoWidth;
          const height = video.videoHeight;
          resolve({ src: url, type: "video", width, height });
        };
      } else {
        // Handle other file types (optional)
        resolve({ src: url, type: "unknown" });
      }
    });
  };

  useEffect(() => {
    if (propertyImages?.length > 0) {
      const fetchImageDimensions = async () => {
        const imageDetails = await Promise.all(
          propertyImages?.map((img) => getMediaDetails(img))
        );
        setGalleryImages(imageDetails);
      };

      fetchImageDimensions();
    }
  }, [propertyImages]);

  useEffect(() => {
    if (floorPlans?.length > 0) {
      const fetchFloorImageDimensions = async () => {
        const imageDetails = await Promise.all(
          floorPlans?.map((img) => getMediaDetails(img))
        );
        setGalleryFloorImages(imageDetails);
      };

      fetchFloorImageDimensions();
    }
  }, [floorPlans]);

  return (
    <>
      {dataLoading ? <LoadingPage /> : ""}

      <Box>
        <Card className={classes.card}>
          {businessId === "9f05fa50-5b7b-4028-bdc7-acf2231795a0" ||
          businessId === "9fe9ad62-6fd4-4e61-9f7d-afaecd9ee92a" ? (
            <>
              {locationLogo || brandImage ? (
                <div className={classes.imgContainer}>
                  <img
                    className={classes.brandImg}
                    src={locationLogo || brandImage}
                    alt=""
                  />
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
          <LayoutGallery
            galleryImages={galleryImages}
            imgLoad={imgLoad}
            classes={classes}
          />
          {galleryImages?.length > 3 && (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                marginTop: 10,
                textAlign: "center",
              }}
            >
              <Button
                size="small"
                startIcon={<PhotoLibrary />}
                className={classes.imgBtn}
                variant="contained"
                color="primary"
                onClick={handleOpenDialog}
              >
                See all {galleryImages?.length} photos
              </Button>
            </Box>
          )}
          <CardContent>
            <Typography variant="h5" gutterBottom>
              {propertyDetails?.address}
            </Typography>
            <Typography variant="h5" color="primary" gutterBottom>
              {propertyDetails?.price
                ? `${CurrencySymbol[propertyDetails?.currency]} ${
                    propertyDetails?.price
                  }`
                : "-"}
            </Typography>
            <Divider />
            <Grid container>
              {propertyDetails?.businesses?.map((bs) => {
                return (
                  <Grid
                    lg={
                      propertyDetails?.businesses?.length === 1
                        ? 12
                        : propertyDetails?.businesses?.length === 2
                        ? 6
                        : 4
                    }
                    md={
                      propertyDetails?.businesses?.length === 1
                        ? 12
                        : propertyDetails?.businesses?.length === 2
                        ? 6
                        : 4
                    }
                    sm={12}
                    xs={12}
                    className={classes.contactWrapper}
                    item
                    key={bs?.propertybusinessid}
                  >
                    {" "}
                    {/* Ensure key is unique */}
                    <Paper className={classes.cardWrapper}>
                      <div className={classes.contactsBox}>
                        <div className={classes.contactInfoWrapper}>
                          {bs?.businessprice ? (
                            <div className={classes.contactDetail}>
                              <Typography className={classes.textStyle}>
                                <strong>Business Value: </strong>
                                {bs?.businessprice
                                  ? `${
                                      CurrencySymbol[propertyDetails?.currency]
                                    } ${bs?.businessprice}`
                                  : "-"}
                              </Typography>
                            </div>
                          ) : (
                            <div className={classes.contactDetailEmpty}>
                              <Typography className={classes.textStyle} />
                            </div>
                          )}
                          {bs?.businesstype !== "Other" ? (
                            <div className={classes.contactDetail}>
                              <Typography className={classes.textStyle}>
                                <strong>Business Type: </strong>
                                {bs?.businesstype || "-"}
                              </Typography>
                            </div>
                          ) : (
                            <div className={classes.contactDetailEmpty}>
                              <Typography className={classes.textStyle} />
                            </div>
                          )}
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
            <Typography className={classes.sectionTitle}>
              Property Details
            </Typography>
            <Grid container spacing={3}>
              {propertyData?.map((detail, index) => (
                <Grid item xs={6} sm={6} md={4} lg={3} key={index}>
                  <div className={classes.detailItem}>
                    {detail.icon && (
                      <div className={classes.detailIcon}>{detail.icon}</div>
                    )}
                    <div>
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: "bold" }}
                        className={classes.hedaing}
                      >
                        {handleUndefined(detail?.label)}
                      </Typography>
                      <Typography variant="body2" className={classes.valueTxt}>
                        {handleUndefined(detail?.value) || "-"}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
            <br />
            <Typography variant="body2" className={classes.descriptionText}>
              {handleUndefined(propertyDetails?.notes) || "-"}
            </Typography>
            <br />
            <Grid container>
              {propertyDetails?.agentUsers?.map((ag) => {
                const fullName = `${handleUndefined(ag?.firstname)} ${
                  handleUndefined(ag?.lastname) || ""
                }`.trim();
                return (
                  <Grid
                    lg={
                      propertyDetails?.agentUsers?.length === 1
                        ? 12
                        : propertyDetails?.agentUsers?.length === 2
                        ? 6
                        : 4
                    }
                    md={propertyDetails?.agentUsers?.length === 1 ? 12 : 6}
                    sm={12}
                    xs={12}
                    className={classes.contactWrapper}
                    item
                    key={ag?.userid}
                  >
                    {" "}
                    {/* Ensure key is unique */}
                    <Paper className={classes.cardWrapper}>
                      <div
                        style={{
                          height: "30px !important",
                        }}
                      >
                        <h6
                        style={{fontSize: 18,borderBottom: "1px solid #ddd",paddingBottom: 10,color: "#333 !important",fontWeight: "bold !important",height: '30px !important'}}
                        >
                          Contact
                        </h6>
                      </div>
                        <br />
                      <div className="contactsBoxAvatarV">
                        {ag?.avatar ? (
                          <div>
                            <div>
                              <Avatar
                                className={classes.aagentAvatar}
                                src={ag?.avatar}
                              />
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className={classes.contactInfoWrapper}>
                          {fullName ? (
                            <div className={classes.contactDetail}>
                              <Person
                                color="primary"
                                className={classes.iconStyle}
                              />
                              <Typography className={classes.textStyle}>
                                <strong>{fullName || "-"}</strong>
                              </Typography>
                            </div>
                          ) : (
                            <div className={classes.contactDetailEmpty}>
                              <Typography className={classes.textStyle} />
                            </div>
                          )}
                          {ag?.email ? (
                            <div className={classes.contactDetail}>
                              <Email
                                color="primary"
                                className={classes.iconStyle}
                              />
                              <Typography className={classes.textStyle}>
                                {ag?.email || "-"}
                              </Typography>
                            </div>
                          ) : (
                            <div className={classes.contactDetailEmpty}>
                              <Typography className={classes.textStyle} />
                            </div>
                          )}
                          {ag?.phonenumber ? (
                            <div className={classes.contactDetail}>
                              <Phone
                                color="primary"
                                className={classes.iconStyle}
                              />
                              <Typography className={classes.textStyle}>
                                {ag?.phonenumber
                                  ? convertToUSPhoneNumber(ag?.phonenumber)
                                  : "-"}
                              </Typography>
                            </div>
                          ) : (
                            <div className={classes.contactDetailEmpty}>
                              <Typography className={classes.textStyle} />
                            </div>
                          )}
                          {ag?.govid ? (
                            <div className={classes.contactDetail}>
                              <AccountCircle
                                color="primary"
                                className={classes.iconStyle}
                              />
                              <Typography className={classes.textStyle}>
                                <strong>Lic #: </strong>
                                {ag?.govid || "-"}
                              </Typography>
                            </div>
                          ) : (
                            <div className={classes.contactDetailEmpty}>
                              <Typography className={classes.textStyle} />
                            </div>
                          )}
                          {ag?.corporatelicno ? (
                            <div className={classes.contactDetail}>
                              <AssignmentInd
                                color="primary"
                                className={classes.iconStyle}
                              />
                              <Typography className={classes.textStyle}>
                                <strong>Corporate Lic #: </strong>
                                {ag?.corporatelicno || "-"}
                              </Typography>
                            </div>
                          ) : (
                            <div className={classes.contactDetailEmpty}>
                              <Typography className={classes.textStyle} />
                            </div>
                          )}
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
            <Grid container className={classes.mapGrid} spacing={2}>
              {floorPlans?.length > 0 ? (
                <Grid
                  item
                  className={classes.grid1}
                  lg={floorPlans?.length > 0 ? 6 : 0}
                  md={floorPlans?.length > 0 ? 6 : 0}
                  sm={floorPlans?.length > 0 ? 6 : 0}
                  xs={floorPlans?.length > 0 ? 12 : 0}
                >
                  <LayoutGallery
                    galleryImages={galleryFloorImages}
                    floorGallery
                    classes={classes}
                  />
                  {galleryFloorImages.length > 1 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "center",
                        marginTop: 10,
                      }}
                    >
                      <Button
                        size="small"
                        startIcon={<PhotoLibrary />}
                        className={classes.imgBtn}
                        variant="contained"
                        color="primary"
                        onClick={handleOpenFloorDialog}
                      >
                        See all {galleryFloorImages?.length} Photos
                      </Button>
                    </div>
                  )}
                </Grid>
              ) : (
                ""
              )}
              <Grid
                item
                className={classes.grid2}
                lg={floorPlans?.length > 0 ? 6 : 12}
                md={floorPlans?.length > 0 ? 6 : 12}
                sm={floorPlans?.length > 0 ? 6 : 12}
                xs={12}
              >
                <div
                  className={classes.mapDiv}
                  style={{ width: "100%", height: "300px" }}
                >
                  {loading ? (
                    <div style={{ height: "300px" }}>Loading...</div>
                  ) : (
                    <div style={{width: '100% !important',height: '300px !important'}}>
                      <GoogleMapComponent
                        address={propertyDetails?.address}
                        apiKey={GOOGLE_MAPS_API_KEY}
                      />
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </CardContent>
          <br />
          <br />
          <PoweredBy id={lid} />
        </Card>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>Property Files</DialogTitle>
          <DialogContent>
            <MediaGallery galleryImages={galleryImages} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openFloorDialog}
          onClose={handleCloseFloorDialog}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>Floor Plans</DialogTitle>
          <DialogContent>
            <MediaGallery galleryImages={galleryFloorImages} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseFloorDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {isOpen && (
          <ReactImageLightbox
            mainSrc={galleryImages[currentImageIndex]?.src}
            nextSrc={
              galleryImages[(currentImageIndex + 1) % galleryImages?.length]
                ?.src
            }
            prevSrc={
              galleryImages[
                (currentImageIndex + galleryImages?.length - 1) %
                  galleryImages?.length
              ]?.src
            }
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setCurrentImageIndex(
                (currentImageIndex + galleryImages?.length - 1) %
                  galleryImages?.length
              )
            }
            onMoveNextRequest={() =>
              setCurrentImageIndex(
                (currentImageIndex + 1) % galleryImages?.length
              )
            }
            wrapperClassName={classes.imageDialog}
          />
        )}
        {isFloorOpen && (
          <ReactImageLightbox
            mainSrc={galleryFloorImages[currentFloorImageIndex]?.src}
            nextSrc={
              galleryFloorImages[
                (currentFloorImageIndex + 1) % galleryFloorImages?.length
              ]?.src
            }
            prevSrc={
              galleryFloorImages[
                (currentFloorImageIndex + galleryFloorImages?.length - 1) %
                  galleryFloorImages?.length
              ]?.src
            }
            onCloseRequest={() => setIsFloorOpen(false)}
            onMovePrevRequest={() =>
              setCurrentFloorImageIndex(
                (currentFloorImageIndex + galleryFloorImages?.length - 1) %
                  galleryFloorImages?.length
              )
            }
            onMoveNextRequest={() =>
              setCurrentFloorImageIndex(
                (currentFloorImageIndex + 1) % galleryFloorImages?.length
              )
            }
            wrapperClassName={classes.imageDialog}
          />
        )}
      </Box>
      <BusinessFavicon
        name={propertyDetails?.address}
        logo={favIcon || locationBrandImage || brandImage}
      />
    </>
  );
};

export default PropertyPublicPage;
